import stylesheet from './DocumentList.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

class NXTDocumentList extends CustomComponent {
    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    render() {
        const container = document.createElement('div');
        container.classList.add(
            'document-list',
        );
        container.innerHTML = `
            <div class="document-list-title"></div>
        `;
        this.cloneSlotContentIntoContainer(container.querySelector('.document-list-title'), 'title');
        this.cloneDefaultSlotContentIntoContainer(container, false);
        return container;
    }

}

customElements.define('nxt-document-list', NXTDocumentList);
